import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import { DominiosListComponent } from './pages/dominios-list/dominios-list.component';
import { DominioListComponent } from './pages/dominio-list/dominio-list.component';
import { DominiosSharedDataService } from './dominios-shared-data.service';
import { DominiosRoutingModule } from './dominios-routing.module';
import { DominioFormComponent } from './pages/dominio-form/dominio-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DominioTreeListComponent } from './pages/dominio-tree-list/dominio-tree-list.component';
import { ListaNiveisDragAndDropComponent } from './components/lista-niveis-drag-and-drop/lista-niveis-drag-and-drop.component';
import { ListaTransferComponent } from './components/lista-transfer/lista-transfer.component';
import { AssociacoesBadgesNzComponent } from './components/associacoes-badges/associacoes-badges-nz.component';

@NgModule({
  declarations: [
    DominiosListComponent,
    DominioListComponent,
    DominioFormComponent,
    DominioTreeListComponent,
    ListaNiveisDragAndDropComponent,
    ListaTransferComponent,
    AssociacoesBadgesNzComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    SharedModule,
    DominiosRoutingModule,
    NgxPermissionsModule.forChild(),
    NgxMaskDirective,
    NgxMaskPipe,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports:[
    ListaNiveisDragAndDropComponent
  ],
  providers:[
    DominiosSharedDataService
  ]
})
export class DominiosModule { }
